var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHopr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.337 7.87c-.28-.04-.52-.04-.799-.04-1.957 0-3.874.8-5.59 2.318-.8.719-1.558 1.598-2.237 2.556-.12-3.715-.319-7.67-.718-11.704H5c1.078 11.345.958 21.252.759 29.96V31h4.99c.16-8.708 2.317-14.3 5.552-17.177.878-.76 1.717-1.119 2.476-1.039 3.953.44 3.315 12.743 3.035 18.216h4.992c.2-4.035.44-8.948-.12-13.182-.799-6.192-3.315-9.508-7.348-9.947z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHopr);
export default __webpack_public_path__ + "static/media/HOPR.b72999f84fc31a0df14085393c8d3642.svg";
export { ForwardRef as ReactComponent };